import React, {useEffect, useState} from 'react';
import {ImageOverlay, MapContainer, Marker, TileLayer, useMap} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './Deminer.css';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';
import L from 'leaflet';
import 'leaflet-control-geocoder';
import { useRef } from 'react';

import ArrowLeft from "../Pictures/Icons/arrow_left_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg"
import Exclamation from "../Pictures/Icons/needHelp_exclamation_priority_high_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg"
import Sidebar from "../Components/Sidebar";

function MapEvents({ onRightClick, onAddAntiTankMine, onAddAntiPersonnelMine, onAddUnknownMine }) {
    const map = useMap();

    useEffect(() => {
        if (!map) return;

        const contextMenuHandler = (e) => {
            const popup = L.popup()
                .setLatLng(e.latlng)
                .setContent(`
                    <div class="map-popup-buttons">
                        <button class="set-center-btn">Set View Center Here</button>
                        <button class="add-anti-tank-mine-btn">Add Anti-Tank Mine</button>
                        <button class="add-anti-personnel-mine-btn">Add Anti-Personnel Mine</button>
                        <button class="add-unknown-mine-btn">Add Unknown Mine</button>
                    </div>
        `)
                .openOn(map);

            setTimeout(() => {
                const setCenterBtn = document.querySelector('.set-center-btn');
                const addAntiTankMineBtn = document.querySelector('.add-anti-tank-mine-btn');
                const addAntiPersonnelMineBtn = document.querySelector('.add-anti-personnel-mine-btn');
                const addUnknownMineBtn = document.querySelector('.add-unknown-mine-btn');
                if (setCenterBtn) {
                    setCenterBtn.addEventListener('click', () => {
                        onRightClick(e.latlng);
                        map.closePopup();
                    });
                }
                if (addAntiTankMineBtn) {
                    addAntiTankMineBtn.addEventListener('click', () => {
                        onAddAntiTankMine(e.latlng);
                        map.closePopup();
                    });
                }

                if (addAntiPersonnelMineBtn) {
                    addAntiPersonnelMineBtn.addEventListener('click', () => {
                        onAddAntiPersonnelMine(e.latlng);
                        map.closePopup();
                    });
                }

                if (addUnknownMineBtn) {
                    addUnknownMineBtn.addEventListener('click', () => {
                        onAddUnknownMine(e.latlng);
                        map.closePopup();
                    });
                }
            }, 0);
        };

        map.on('contextmenu', contextMenuHandler);
        return () => map.off('contextmenu', contextMenuHandler);
    }, [map, onRightClick, onAddAntiTankMine, onAddAntiPersonnelMine, onAddUnknownMine]);
    return null;
}

function Deminer() {
    const mapRef = useRef();
    const [fitCenter, setFitCenter] = useState([50.4501, 30.5234]); // Default: Kyiv
    const [status, setStatus] = useState('not started'); //Status for the left sidebar
    const [mines, setMines] = useState([]);
    const [selectedMine, setSelectedMine] = useState(null);

    const [helpRequested, setHelpRequested] = useState(false); //For storing if request help is coloured
    const [activeSetting, setActiveSetting] = useState(null);
    const [showSettingsMenu, setShowSettingsMenu] = useState(false);
    const [showHeatmap, setShowHeatmap] = useState(false);

    const colorOptions = [
        { value: '#FF0000', label: 'Anti-Tank Mine'},
        { value: '#FFA500', label: 'Anti-Personnel Mine'},
        { value: '#FFFF00', label: 'Unknown Mine'},
        { value: '#118ACB', label: 'Demined'}
    ];
    const eventTypeColors = {
        detected: '#FF0000',
        cleared:  '#00FF00',
        scouted: '#118ACB',

        // Add more types as needed
    };
    const exampleHistory = [
        {
            type: 'detected',
            description: 'Anti-Tank Mine detected at (50.450, 30.523)',
            timestamp: '2024-06-04 10:15:00'
        },
        {
            type: 'cleared',
            description: 'Mined Area at (50.455, 30.530)',
            timestamp: '2024-06-04 11:00:00'
        },
        {
            type: 'scouted',
            description: 'Area scouted at (50.460, 30.540)',
            timestamp: '2024-06-04 12:30:00'
        },
        {
            type: 'cleared',
            description: 'Area reclaimed at (50.465, 30.500)',
            timestamp: '2024-06-04 13:30:00'
        }
    ];
    const [history, setHistory] = useState(exampleHistory);

    const historyContent = (
        <div className="scroll-menu">
            <ul>
                {history.map((event, i) => (
                    <li key={i} style={{ color: eventTypeColors[event.type] || '#000' }}>
                        <strong>{event.type.charAt(0).toUpperCase() + event.type.slice(1)}:</strong> {event.description}
                        <span style={{ fontSize: '0.8em', color: '#888', marginLeft: 8 }}>{event.timestamp}</span>
                    </li>
                ))}
            </ul>
        </div>
    );



    const rightbarMap = {
        history: historyContent,
        assets: (
            <div className="scroll-menu">
                <ul>
                    {
                        mines.map((mine, index) => (
                            <li className={"asset-list-element"} key={index} onClick={() => { setSelectedMine(index); setIsRightSidebarExpanded(true); }}>
                                {mine.name || `Mine ${index + 1}`} - Lat: {mine.lat.toFixed(3)}, Lng: {mine.lng.toFixed(3)} {''}
                                <span
                                    style={{
                                        display: 'inline-block',
                                        width: '14px',
                                        height: '14px',
                                        borderRadius: '50%',
                                        backgroundColor: mine.color || '#118ACB',
                                        marginRight: '8px',
                                        verticalAlign: '-px'
                                    }}
                                />
                            </li>
                        ))
                    }
                </ul>
            </div>
        ),
        settings: (
            <div className="scroll-menu">
                <label className="heatmap-toggle">
                    <input
                        type="checkbox"
                        checked={showHeatmap}
                        onChange={(e) => setShowHeatmap(e.target.checked)}
                    />
                    <span className="slider"></span>
                    <span className="toggle-label">Heat Map</span>
                </label>
            </div>
        )
    };

    const [isRightSidebarExpanded, setIsRightSidebarExpanded] = useState(false);
    const toggleRightSidebar = () => {
        setIsRightSidebarExpanded(prevState => !prevState);
    };

    const handleFitMap = () => {
        const map = mapRef.current;
        if (map && fitCenter) {
            map.setView(fitCenter, 20);
        }
    };

    const handleRightClick = (latlng) => {
        setFitCenter([latlng.lat, latlng.lng]);
    };

    const handleToggleSection = (section) => {
        setShowSettingsMenu(prev => !(activeSetting === section && prev));
        setActiveSetting(section);
    };

    const handleAddAntiTankMine = (latlng) => {
        setMines(prev => [...prev, {
            lat: latlng.lat,
            lng: latlng.lng,
            color: '#FF0000', // Red for Anti-Tank Mine
            type: 'anti-tank'
        }]);
    };

    const handleAddAntiPersonnelMine = (latlng) => {
        setMines(prev => [...prev, {
            lat: latlng.lat,
            lng: latlng.lng,
            color: '#FFA500', // Orange for Anti-Personnel Mine
            type: 'anti-personnel'
        }]);
    };

    const handleAddUnknownMine = (latlng) => {
        setMines(prev => [...prev, {
            lat: latlng.lat,
            lng: latlng.lng,
            color: '#FFFF00', // Yellow for Unknown Mine
            type: 'unknown'
        }]);
    };

    const handleMineClick = (index) => {
        setSelectedMine(prevSelected => prevSelected === index ? null : index);
        setIsRightSidebarExpanded(true);
    };

    const handleColorChange = (color) => {
        if (selectedMine !== null) {
            setMines(prev => prev.map((mine, i) => {
                if (i === selectedMine) {
                    return { ...mine, color: color };
                }
                return mine;
            }));
        }
    };

    const handleMineMove = (index, newPosition) => {
        setMines(prev => prev.map((mine, i) => {
            if (i === index) {
                return {
                    ...mine,
                    lat: newPosition[0],
                    lng: newPosition[1]
                };
            }
            return mine;
        }));
    };


    const handleDeleteMine = (indexToDelete) => {
        setMines(prev => prev.filter((_, index) => index !== indexToDelete));
        setSelectedMine(null); // Reset selectedMine after deletion
        setIsRightSidebarExpanded(false); // Close the sidebar
    };

    useEffect(() => {
        if (selectedMine === null && isRightSidebarExpanded) {
            setIsRightSidebarExpanded(false);
        }
    }, [selectedMine]);

    return (
        <div className="app-container">
            <Sidebar
                onFitMap={handleFitMap}
                onToggleSection={handleToggleSection}
                activeSetting={activeSetting}
                showSettingsMenu={showSettingsMenu}
                contentMap={rightbarMap}
            />
            <div className="map-container">
                <MapContainer
                    center={fitCenter}
                    zoom={20}
                    scrollWheelZoom={true}
                    style={{height: "100%", width: "100%"}}
                    ref={mapRef}
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {showHeatmap && (
                        <ImageOverlay
                            url="/thermal2.svg"
                            bounds={mapRef.current.getBounds()}
                            //bounds={[[-90, -180], [90, 180]]}
                            opacity={0.7}
                        />
                    )}
                    {mines.map((mine, index) => (
                        <Marker
                            key={index}
                            position={[mine.lat, mine.lng]}
                            icon={L.divIcon({
                                className: 'custom-mine-icon',
                                html: `<div style="
                                    color: ${mine.color}; 
                                    text-shadow: ${selectedMine === index
                                    ? '0 0 3px #00FF00, -1px -1px 0 #00FF00, 1px -1px 0 #00FF00, -1px 1px 0 #00FF00, 1px 1px 0 #00FF00'
                                    : '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000'
                                };">✛</div>`,
                                iconSize: [20, 20]
                            })}
                            draggable={true}
                            eventHandlers={{
                                click: () => handleMineClick(index),
                                dragend: (e) => handleMineMove(index, [e.target.getLatLng().lat, e.target.getLatLng().lng])
                            }}
                        />
                    ))}
                    <MapEvents onRightClick={handleRightClick}
                               onAddAntiTankMine={handleAddAntiTankMine}
                               onAddAntiPersonnelMine={handleAddAntiPersonnelMine}
                               onAddUnknownMine={handleAddUnknownMine}
                    />
                </MapContainer>
            </div>

            <div className={`sidebar right ${isRightSidebarExpanded ? 'expanded' : ''}`}>
                <div className={`right-sidebar-content ${isRightSidebarExpanded ? 'visible' : ''}`}>
                    {selectedMine !== null && (
                        <>
                            <h2>Status</h2>
                            <select
                                id="status-select"
                                className="status-dropdown"
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}
                            >
                                <option value="notStarted">Not Started</option>
                                <option value="active">Active</option>
                                <option value="demined">Demined</option>
                                <option value ="falseAlarm">False Alarm</option>
                            </select>
                            <h2>Mine Details</h2>
                            <div className="object-details">
                                <div className="detail-item">
                                    <label>Location:</label>
                                    <p>Lat: {mines[selectedMine].lat.toFixed(6)}</p>
                                    <p>Lng: {mines[selectedMine].lng.toFixed(6)}</p>
                                </div>
                                <div className="detail-item">
                                    <label>Type:</label>
                                    <div className="custom-select-wrapper">
                                        <select
                                            className="color-dropdown"
                                            value={mines[selectedMine].color}
                                            onChange={(e) => handleColorChange(e.target.value)}
                                            style={{
                                                color: mines[selectedMine].color,
                                                borderColor: mines[selectedMine].color,
                                                backgroundColor: `${mines[selectedMine].color}1A` // 0.1 opacity in hex (1A)
                                            }}
                                        >
                                            {colorOptions.map((option) => (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                    style={{ backgroundColor: option.value }}
                                                >
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div>
                                    <label style={{ fontWeight: 'bold' }}>Tools Needed:</label>
                                    <ul>
                                        <li>Metal Detector</li>
                                        <li>GPS Tracker</li>
                                        <li>Safety Equipment</li>
                                    </ul>
                                </div>


                                <br/>
                                <br/>
                            </div>
                            <button
                                className={`sidebar-btn help-button ${helpRequested ? 'active' : ''}`}
                                onClick={() => setHelpRequested(!helpRequested)}
                            >
                                <img src={Exclamation} alt="Logo" style={{width: '40px', height: 'auto'}}/>
                                Request Help
                            </button>

                            <div className="detail-item">
                                <button
                                    className="sidebar-btn delete-button"
                                    onClick={() => handleDeleteMine(selectedMine)}
                                >
                                    Delete Mine
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <button
                className="expand-button"
                onClick={toggleRightSidebar}
                disabled={selectedMine === null}
                aria-label={isRightSidebarExpanded ? "Collapse sidebar" : "Expand sidebar"}
            >
                <img
                    src={ArrowLeft}
                    alt="Toggle sidebar"
                    className={isRightSidebarExpanded ? 'rotated' : ''}
                />
            </button>
        </div>
    );
}

export default Deminer;